<template>
  <div class="text-center">
    <v-progress-circular v-bind="$attrs" color="secondary" indeterminate />
  </div>
</template>
